//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapMutations } from 'vuex'
import rules from '../../plugins/rules'

export default {
  data() {
    return {
      phoneNumber: '',
      verifyPic: '',
      smsVerifyCode: '',
      sendSmsButtonMessage: '发送验证码',
      isSendSmsVerifyCodeDisabled: false,
      sendSmsCountDown: 60,
      sendSmsInterval: null,
      rules,
      fetchedUserInfo: null,
    }
  },

  methods: {
    ...mapMutations('user', ['updateUserInfo']),
    ...mapActions('user', ['smsLogin']),

    sendSms() {
      this.phoneNumber = this.phoneNumber.trim()
      this.$nextTick(() => {
        if (this.$refs.phoneNumber.validate()) {
          this.isSendSmsVerifyCodeDisabled = true
          this.$store.dispatch('user/sendSms', {
            mobile: this.phoneNumber,
            picVerifyCodeStr: this.picVerifyCode,
            callback: () => {
              this.$refs.smsVerifyCode.focus()

              // 先执行一次计时器的第一秒
              this.sendSmsCountDown--
              this.sendSmsButtonMessage = `${this.sendSmsCountDown}秒后可重发`
              // 开始 60 秒倒计时
              this.sendSmsInterval = window.setInterval(() => {
                if (this.sendSmsCountDown != 0) {
                  this.sendSmsCountDown--
                  this.sendSmsButtonMessage = `${this.sendSmsCountDown}秒后可重发`
                } else {
                  window.clearInterval(this.sendSmsInterval)
                  this.sendSmsCountDown = 60
                  this.sendSmsButtonMessage = `发送验证码`
                  this.isSendSmsVerifyCodeDisabled = false
                }
              }, 1000)
            },
            errorCallback: (res) => {
              console.log(res)
              if (res.data.code == 400) {
                this.$q.notify('图形验证码错误')
              } else {
                this.$q.notify(`发送短信验证码失败，请联系管理员，错误代码：${this.data.code}`)
              }
              this.refreshVerificationPic()
            },
          })
        }
      })
    },

    resetValidation(refsName) {
      this.$refs[refsName].resetValidation()
    },

    loginWithSms() {
      /**
       * 利用 Quasar QInput 自带的异步规则验证来登录，使得登录失败的错误信息原生呈现在 QInput 下方
       * validate() 会先调用 rules.required() 方法，这步出错则返回 false
       * 然后调用下面的 asyncVerifyCode() 方法，这步 validate() 会返回 Promise 实例
       */
      const result = this.$refs.smsVerifyCode.validate() // result 可能返回 Promise 实例，也可能返回 Boolean 值
      if (!result.then) return // 如果返回 Boolean 值，说明第一关都没过，直接 return
      result.then((valid) => {
        if (!valid) return // 激活不成功
        // 若尝试登录成功，检测该用户是否激活，如果已激活，成功让其登录
        if (this.fetchedUserInfo.activated != false) {
          this.$router.push('/collection')
        }
        // 如果是未激活的用户，跳转激活界面
        else {
          this.$emit('inactivatedUserDetected', this.fetchedUserInfo)
        }
      })
    },

    asyncVerifyCode(smsCode) {
      return new Promise((resolve) => {
        this.smsLogin({
          mobile: this.phoneNumber,
          code: smsCode,
          callback: (newUserInfo) => {
            this.fetchedUserInfo = newUserInfo
            resolve(true)
          },
          errorCallback: (res) => {
            if (res.data.code == 400) resolve('验证码错误')
            else {
              console.log(res)
              resolve(`发送短信验证码失败，错误信息：${res.data.code || res.message}`)
            }
          },
        })
      })
    },
  },

  mounted() {
    this.$refs.phoneNumber.focus()
  },

  beforeDestroy() {
    window.clearInterval(this.sendSmsInterval)
  },
}
